export default __webpack_public_path__ + "static/media/up.6221126b.svg";